module.exports = __webpack_public_path__ + "assets/img/station29.b88696b9.png";